import { Component, OnInit } from '@angular/core';
import { AppService } from 'app/app.service';
import { Router } from '@angular/router';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { RemoteServicesProvider } from 'providers/remote-services/remote-services';
import { LoginProvider } from 'providers/login/login';
import { TranslationProvider } from 'providers/translation/translation';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { fadeInSlideAnimation } from 'animations';
import { TranslateService } from '@ngx-translate/core';
import { SpotData } from 'dto';
import { GetServiceUrl } from 'psapp-config';
import { PopupMessage, MessageService } from 'rb-core-library';
import * as _ from 'lodash';

declare var window:any;

@Component({
    selector: 'app-newpos',
    templateUrl: './newpos.component.html',
    styleUrls: ['./newpos.component.scss'],

    animations: [fadeInSlideAnimation],
    host: { '[@fadeInSlideAnimation]': '' }
})
export class NewposComponent implements OnInit {

    newPOSData: PosData = null;
    statusCode = null;
    isLoading:boolean = false;

    posTypeList = [];
    isPOSCodeEnabled:boolean = false;
    selectedGroup = null;

    swiperConfig: SwiperConfigInterface = {
        direction: 'horizontal',
        pagination: true,
        spaceBetween: 10,
        slidesPerView: 'auto'
    };

    imageService = GetServiceUrl("GetPOSTypeImage");

    constructor(
        private router: Router,
        private appService: AppService,
        public translationProvider: TranslationProvider,
        private domainStorageProvider: DomainStorageProvider,
        private remoteServicesProvider: RemoteServicesProvider,
        private translateService: TranslateService,
        private loginProvider: LoginProvider,
        public messageService: MessageService
    ) {
        this.showHideMenu(false);
        this.messageService.popupMessage = null;
        let marker = this.domainStorageProvider.rootStore.selectedPOS.getValue();
        if (marker) {
            this.loadData(marker);
        }
        else {
            this.back();
        }
    }

    async loadData(marker:any){
        //refresh groups
        await this.domainStorageProvider.getConfigData(false);

        this.selectedGroup = this.domainStorageProvider.rootStore.getSelectedGroup();
        if(this.selectedGroup){
            this.posTypeList = this.domainStorageProvider.rootStore.posTypeList;
            this.isPOSCodeEnabled = /*this.domainStorageProvider.rootStore.config.enablePosCode ||*/ this.selectedGroup.enablePosCode;

            this.newPOSData = new PosData(marker.name, marker, this.isPOSCodeEnabled);
        }
        else{
            this.messageService.addMessage( {
                type: 'danger',
                text: this.translateService.instant("App.MustChooseCampaign"),
                timeout: 3000
            });
        }
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    back() {
        this.router.navigate(["/searchpos"]);
    }

    cancelCreatePos() {
        this.router.navigate(["/searchpos"]);
    }

    presentLoading() {
        this.isLoading = true;
    }

    dismissLoading() {
        this.isLoading = false;
    }

    loadNotFoundImage(image) {
        image.src = "assets/imgs/rb_product_placeholder.jpg";
    }

    async confirmAction() {
        if (this.newPOSData && this.newPOSData.isValid()) {
            
            //track
            var posType = _.find(this.posTypeList, item => item.id == this.newPOSData.posTypeId);
            if(posType){
                var contentId = this.appService.url2contentId("/create");
                window.wts.push(['send', 'click', { linkId: contentId, customClickParameter: { 1: 'button', 2: 'footer', 3: posType["type"] } }]);
            }
            
            this.presentLoading();
            await this.remoteServicesProvider
                .sendPos(this.newPOSData, this.loginProvider.token)
                .then((result:any) => {
                    this.dismissLoading();

                    if (result) {
                        if (result.id === -1) {
                            let popupMessage: PopupMessage = {
                                type: 'danger',
                                text: this.translateService.instant("SearchPosPage.ErrorRegisterPOSExisting"),
                                timeout: 3000
                            };
                            this.messageService.addMessage(popupMessage);
                        }
                        else {
                            //set selected POS
                            this.domainStorageProvider.rootStore.selectedPOS.next({
                                id: result.id,
                                name: result.name,
                                address: result.address,
                                location: result.location,
                            });
        
                            //set new spot data
                            this.domainStorageProvider.rootStore.spotData.next(new SpotData(
                                this.domainStorageProvider.rootStore.selectedPOS.value,
                                this.selectedGroup
                            ));
        
                            this.router.navigate(["/newspot"]);
                        }
                    }
                });
                this.dismissLoading();
        }
    }
}


class PosData {
    requirePOSCode:boolean;
    id;
    name;
    posTypeId;
    posCode;
    address;
    marker;

    constructor(name, marker, requirePOSCode:boolean) {
        if (name) {
            this.name = name;
        }
        this.requirePOSCode = requirePOSCode;
        this.marker = marker;
        if(this.marker){
            if(this.marker.id){
                this.id = this.marker.id;
            }
            if(this.marker.address){
                this.address = this.marker.address;
            }
            if(this.marker.posCode){
                this.posCode = this.marker.posCode;
            }
            if(this.marker.posTypeId){
                this.posTypeId = this.marker.posTypeId;
            }
        }
    }

    isValid() {
        if (this.name  && this.address && this.posTypeId && (!this.requirePOSCode || this.posCode)) {
            return true;
        }

        return false;
    }
}

